import { render } from "./ReservedTicketsDetails.vue?vue&type=template&id=cfa74be0&scoped=true"
import script from "./ReservedTicketsDetails.vue?vue&type=script&lang=js"
export * from "./ReservedTicketsDetails.vue?vue&type=script&lang=js"

import "./ReservedTicketsDetails.vue?vue&type=style&index=0&id=cfa74be0&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa74be0"]])

export default __exports__